export const assistancesVi = [
  { id: '1', value: 'Không' },
  { id: '13', value: 'Không, nhưng tôi cần một số hỗ trợ (Giao từng cửa)' },
  { id: '4', value: 'Xe lăn (không chuyển được)' },
  { id: '15', value: 'Xe lăn (có thể chuyển)' },
  { id: '3', value: 'Khung hoặc xe tập đi' },
  { id: '6', value: 'Tôi cần một cái gurney hoặc cáng' },
  { id: '9', value: 'Mileage Reimbursement' },
];
